'use strict';

module.exports = function dump() {
  // eslint-disable-next-line
  console.log(this);
  return this;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/collect.js/dist/methods/dump.js
// module id = ./node_modules/collect.js/dist/methods/dump.js
// module chunks = 0